import { CardEnum, CardTypeEnum } from '@colonist/game-states';
import CardResCardBack from '@static/images/card_rescardback.svg';
import CardLumber from '@static/images/card_lumber.svg';
import CardBrick from '@static/images/card_brick.svg';
import CardWool from '@static/images/card_wool.svg';
import CardGrain from '@static/images/card_grain.svg';
import CardOre from '@static/images/card_ore.svg';
import CardCloth from '@static/images/card_cloth.svg';
import CardCoin from '@static/images/card_coin.svg';
import CardPaper from '@static/images/card_paper.svg';
import CardDevCardBack from '@static/images/card_devcardback.svg';
import CardKnight from '@static/images/card_knight.svg';
import CardVp from '@static/images/card_vp.svg';
import CardMonopoly from '@static/images/card_monopoly.svg';
import CardRoadbuilding from '@static/images/card_roadbuilding.svg';
import CardYearOfPlenty from '@static/images/card_yearofplenty.svg';
import CardProgressTradeBack from '@static/images/card_progress_trade_back.svg';
import CardProgressTradeCommercialHarbor from '@static/images/card_progress_trade_commercial_harbor.svg';
import CardProgressTradeMasterMerchant from '@static/images/card_progress_trade_master_merchant.svg';
import CardProgressTradeMerchant from '@static/images/card_progress_trade_merchant.svg';
import CardProgressTradeMerchantFleet from '@static/images/card_progress_trade_merchant_fleet.svg';
import CardProgressTradeResourceMonopoly from '@static/images/card_progress_trade_resource_monopoly.svg';
import CardProgressTradeCommodityMonopoly from '@static/images/card_progress_trade_commodity_monopoly.svg';
import CardProgressPoliticsBack from '@static/images/card_progress_politics_back.svg';
import CardProgressPoliticsBishop from '@static/images/card_progress_politics_bishop.svg';
import CardProgressPoliticsConstitution from '@static/images/card_progress_politics_constitution.svg';
import CardProgressPoliticsDeserter from '@static/images/card_progress_politics_deserter.svg';
import CardProgressPoliticsDiplomat from '@static/images/card_progress_politics_diplomat.svg';
import CardProgressPoliticsIntrigue from '@static/images/card_progress_politics_intrigue.svg';
import CardProgressPoliticsSaboteur from '@static/images/card_progress_politics_saboteur.svg';
import CardProgressPoliticsSpy from '@static/images/card_progress_politics_spy.svg';
import CardProgressPoliticsWarlord from '@static/images/card_progress_politics_warlord.svg';
import CardProgressPoliticsWedding from '@static/images/card_progress_politics_wedding.svg';
import CardProgressScienceBack from '@static/images/card_progress_science_back.svg';
import CardProgressScienceAlchemist from '@static/images/card_progress_science_alchemist.svg';
import CardProgressScienceCrane from '@static/images/card_progress_science_crane.svg';
import CardProgressScienceEngineer from '@static/images/card_progress_science_engineer.svg';
import CardProgressScienceInventor from '@static/images/card_progress_science_inventor.svg';
import CardProgressScienceIrrigation from '@static/images/card_progress_science_irrigation.svg';
import CardProgressScienceMedicine from '@static/images/card_progress_science_medicine.svg';
import CardProgressScienceMining from '@static/images/card_progress_science_mining.svg';
import CardProgressSciencePrinter from '@static/images/card_progress_science_printer.svg';
import CardProgressScienceRoadBuilding from '@static/images/card_progress_science_road_building.svg';
import CardProgressScienceSmith from '@static/images/card_progress_science_smith.svg';
import CardProgressBack from '@static/images/card_progress_back.svg';
import CardResourceOverLimit from '@static/images/card_rescardoverlimit.svg';
export const CARD_IMAGES = {
    [CardEnum.ResourceBack]: CardResCardBack,
    [CardEnum.Lumber]: CardLumber,
    [CardEnum.Brick]: CardBrick,
    [CardEnum.Wool]: CardWool,
    [CardEnum.Grain]: CardGrain,
    [CardEnum.Ore]: CardOre,
    [CardEnum.Cloth]: CardCloth,
    [CardEnum.Coin]: CardCoin,
    [CardEnum.Paper]: CardPaper,
    [CardEnum.AnyResource]: CardResCardBack,
    [CardEnum.DevelopmentBack]: CardDevCardBack,
    [CardEnum.Knight]: CardKnight,
    [CardEnum.VictoryPoint]: CardVp,
    [CardEnum.Monopoly]: CardMonopoly,
    [CardEnum.RoadBuilding]: CardRoadbuilding,
    [CardEnum.YearOfPlenty]: CardYearOfPlenty,
    [CardEnum.CommodityBack]: CardResCardBack,
    [CardEnum.ProgressCardTradeBack]: CardProgressTradeBack,
    [CardEnum.ProgressCardTradeCommercialHarbor]: CardProgressTradeCommercialHarbor,
    [CardEnum.ProgressCardTradeMasterMerchant]: CardProgressTradeMasterMerchant,
    [CardEnum.ProgressCardTradeMerchant]: CardProgressTradeMerchant,
    [CardEnum.ProgressCardTradeMerchantFleet]: CardProgressTradeMerchantFleet,
    [CardEnum.ProgressCardTradeResourceMonopoly]: CardProgressTradeResourceMonopoly,
    [CardEnum.ProgressCardTradeCommodityMonopoly]: CardProgressTradeCommodityMonopoly,
    [CardEnum.ProgressCardPoliticsBack]: CardProgressPoliticsBack,
    [CardEnum.ProgressCardPoliticsBishop]: CardProgressPoliticsBishop,
    [CardEnum.ProgressCardPoliticsConstitution]: CardProgressPoliticsConstitution,
    [CardEnum.ProgressCardPoliticsDeserter]: CardProgressPoliticsDeserter,
    [CardEnum.ProgressCardPoliticsDiplomat]: CardProgressPoliticsDiplomat,
    [CardEnum.ProgressCardPoliticsIntrigue]: CardProgressPoliticsIntrigue,
    [CardEnum.ProgressCardPoliticsSaboteur]: CardProgressPoliticsSaboteur,
    [CardEnum.ProgressCardPoliticsSpy]: CardProgressPoliticsSpy,
    [CardEnum.ProgressCardPoliticsWarlord]: CardProgressPoliticsWarlord,
    [CardEnum.ProgressCardPoliticsWedding]: CardProgressPoliticsWedding,
    [CardEnum.ProgressCardScienceBack]: CardProgressScienceBack,
    [CardEnum.ProgressCardScienceAlchemist]: CardProgressScienceAlchemist,
    [CardEnum.ProgressCardScienceCrane]: CardProgressScienceCrane,
    [CardEnum.ProgressCardScienceEngineer]: CardProgressScienceEngineer,
    [CardEnum.ProgressCardScienceInventor]: CardProgressScienceInventor,
    [CardEnum.ProgressCardScienceIrrigation]: CardProgressScienceIrrigation,
    [CardEnum.ProgressCardScienceMedicine]: CardProgressScienceMedicine,
    [CardEnum.ProgressCardScienceMining]: CardProgressScienceMining,
    [CardEnum.ProgressCardSciencePrinter]: CardProgressSciencePrinter,
    [CardEnum.ProgressCardScienceRoadBuilding]: CardProgressScienceRoadBuilding,
    [CardEnum.ProgressCardScienceSmith]: CardProgressScienceSmith,
    [CardEnum.ProgressCardBack]: CardProgressBack,
    [CardEnum.ResourceOverLimit]: CardResourceOverLimit
};
export const CARD_TIP_TITLE = {
    [CardEnum.ResourceBack]: {
        key: 'strings:game.cards.resource.back.title'
    },
    [CardEnum.Lumber]: {
        key: 'strings:game.cards.resource.lumber.title'
    },
    [CardEnum.Brick]: {
        key: 'strings:game.cards.resource.brick.title'
    },
    [CardEnum.Wool]: {
        key: 'strings:game.cards.resource.wool.title'
    },
    [CardEnum.Grain]: {
        key: 'strings:game.cards.resource.grain.title'
    },
    [CardEnum.Ore]: {
        key: 'strings:game.cards.resource.ore.title'
    },
    [CardEnum.Cloth]: {
        key: 'strings:game.cards.commodity.cloth.title'
    },
    [CardEnum.Coin]: {
        key: 'strings:game.cards.commodity.coin.title'
    },
    [CardEnum.Paper]: {
        key: 'strings:game.cards.commodity.paper.title'
    },
    [CardEnum.AnyResource]: {
        key: 'strings:game.cards.resource.anyResource.title'
    },
    [CardEnum.DevelopmentBack]: {
        key: 'strings:game.cards.development.back.title'
    },
    [CardEnum.Knight]: {
        key: 'strings:game.cards.development.knight.title'
    },
    [CardEnum.VictoryPoint]: {
        key: 'strings:game.cards.development.victoryPoint.title'
    },
    [CardEnum.Monopoly]: {
        key: 'strings:game.cards.development.monopoly.title'
    },
    [CardEnum.RoadBuilding]: {
        key: 'strings:game.cards.development.roadBuilding.title'
    },
    [CardEnum.YearOfPlenty]: {
        key: 'strings:game.cards.development.yearOfPlenty.title'
    },
    [CardEnum.CommodityBack]: {
        key: 'strings:game.cards.commodity.back.title'
    },
    [CardEnum.ProgressCardTradeBack]: {
        key: 'strings:game.cards.progress.trade.back.title'
    },
    [CardEnum.ProgressCardTradeCommercialHarbor]: {
        key: 'strings:game.cards.progress.trade.commercialHarbor.title'
    },
    [CardEnum.ProgressCardTradeMasterMerchant]: {
        key: 'strings:game.cards.progress.trade.masterMerchant.title'
    },
    [CardEnum.ProgressCardTradeMerchant]: {
        key: 'strings:game.cards.progress.trade.merchant.title'
    },
    [CardEnum.ProgressCardTradeMerchantFleet]: {
        key: 'strings:game.cards.progress.trade.merchantFleet.title'
    },
    [CardEnum.ProgressCardTradeResourceMonopoly]: {
        key: 'strings:game.cards.progress.trade.resourceMonopoly.title'
    },
    [CardEnum.ProgressCardTradeCommodityMonopoly]: {
        key: 'strings:game.cards.progress.trade.commodityMonopoly.title'
    },
    [CardEnum.ProgressCardPoliticsBack]: {
        key: 'strings:game.cards.progress.politics.back.title'
    },
    [CardEnum.ProgressCardPoliticsBishop]: {
        key: 'strings:game.cards.progress.politics.bishop.title'
    },
    [CardEnum.ProgressCardPoliticsConstitution]: {
        key: 'strings:game.cards.progress.politics.constitution.title'
    },
    [CardEnum.ProgressCardPoliticsDeserter]: {
        key: 'strings:game.cards.progress.politics.deserter.title'
    },
    [CardEnum.ProgressCardPoliticsDiplomat]: {
        key: 'strings:game.cards.progress.politics.diplomat.title'
    },
    [CardEnum.ProgressCardPoliticsIntrigue]: {
        key: 'strings:game.cards.progress.politics.intrigue.title'
    },
    [CardEnum.ProgressCardPoliticsSaboteur]: {
        key: 'strings:game.cards.progress.politics.saboteur.title'
    },
    [CardEnum.ProgressCardPoliticsSpy]: {
        key: 'strings:game.cards.progress.politics.spy.title'
    },
    [CardEnum.ProgressCardPoliticsWarlord]: {
        key: 'strings:game.cards.progress.politics.warlord.title'
    },
    [CardEnum.ProgressCardPoliticsWedding]: {
        key: 'strings:game.cards.progress.politics.wedding.title'
    },
    [CardEnum.ProgressCardScienceBack]: {
        key: 'strings:game.cards.progress.science.back.title'
    },
    [CardEnum.ProgressCardScienceAlchemist]: {
        key: 'strings:game.cards.progress.science.alchemist.title'
    },
    [CardEnum.ProgressCardScienceCrane]: {
        key: 'strings:game.cards.progress.science.crane.title'
    },
    [CardEnum.ProgressCardScienceEngineer]: {
        key: 'strings:game.cards.progress.science.engineer.title'
    },
    [CardEnum.ProgressCardScienceInventor]: {
        key: 'strings:game.cards.progress.science.inventor.title'
    },
    [CardEnum.ProgressCardScienceIrrigation]: {
        key: 'strings:game.cards.progress.science.irrigation.title'
    },
    [CardEnum.ProgressCardScienceMedicine]: {
        key: 'strings:game.cards.progress.science.medicine.title'
    },
    [CardEnum.ProgressCardScienceMining]: {
        key: 'strings:game.cards.progress.science.mining.title'
    },
    [CardEnum.ProgressCardSciencePrinter]: {
        key: 'strings:game.cards.progress.science.printer.title'
    },
    [CardEnum.ProgressCardScienceRoadBuilding]: {
        key: 'strings:game.cards.progress.science.roadBuilding.title'
    },
    [CardEnum.ProgressCardScienceSmith]: {
        key: 'strings:game.cards.progress.science.smith.title'
    },
    [CardEnum.ProgressCardBack]: {
        key: 'strings:game.cards.progress.title.ProgressCards'
    },
    [CardEnum.ResourceOverLimit]: {
        key: 'strings:game.playerInformation.resourceCard.title'
    }
};
export const CARD_TIP_BODY = {
    [CardEnum.ResourceBack]: {
        key: 'strings:game.cards.resource.back.body'
    },
    [CardEnum.Lumber]: {
        key: 'strings:game.cards.resource.lumber.body'
    },
    [CardEnum.Brick]: {
        key: 'strings:game.cards.resource.brick.body'
    },
    [CardEnum.Wool]: {
        key: 'strings:game.cards.resource.wool.body'
    },
    [CardEnum.Grain]: {
        key: 'strings:game.cards.resource.grain.body'
    },
    [CardEnum.Ore]: {
        key: 'strings:game.cards.resource.ore.body'
    },
    [CardEnum.Cloth]: {
        key: 'strings:game.cards.commodity.cloth.body'
    },
    [CardEnum.Coin]: {
        key: 'strings:game.cards.commodity.coin.body'
    },
    [CardEnum.Paper]: {
        key: 'strings:game.cards.commodity.paper.body'
    },
    [CardEnum.AnyResource]: {
        key: 'strings:game.cards.resource.anyResource.body'
    },
    [CardEnum.DevelopmentBack]: {
        key: 'strings:game.cards.development.back.body'
    },
    [CardEnum.Knight]: {
        key: 'strings:game.cards.development.knight.body'
    },
    [CardEnum.VictoryPoint]: {
        key: 'strings:game.cards.development.victoryPoint.body'
    },
    [CardEnum.Monopoly]: {
        key: 'strings:game.cards.development.monopoly.body'
    },
    [CardEnum.RoadBuilding]: {
        key: 'strings:game.cards.development.roadBuilding.body'
    },
    [CardEnum.YearOfPlenty]: {
        key: 'strings:game.cards.development.yearOfPlenty.body'
    },
    [CardEnum.CommodityBack]: {
        key: 'strings:game.cards.commodity.back.body'
    },
    [CardEnum.ProgressCardTradeBack]: {
        key: 'strings:game.cards.progress.trade.back.body'
    },
    [CardEnum.ProgressCardTradeCommercialHarbor]: {
        key: 'strings:game.cards.progress.trade.commercialHarbor.body'
    },
    [CardEnum.ProgressCardTradeMasterMerchant]: {
        key: 'strings:game.cards.progress.trade.masterMerchant.body'
    },
    [CardEnum.ProgressCardTradeMerchant]: {
        key: 'strings:game.cards.progress.trade.merchant.body'
    },
    [CardEnum.ProgressCardTradeMerchantFleet]: {
        key: 'strings:game.cards.progress.trade.merchantFleet.body'
    },
    [CardEnum.ProgressCardTradeResourceMonopoly]: {
        key: 'strings:game.cards.progress.trade.resourceMonopoly.body'
    },
    [CardEnum.ProgressCardTradeCommodityMonopoly]: {
        key: 'strings:game.cards.progress.trade.commodityMonopoly.body'
    },
    [CardEnum.ProgressCardPoliticsBack]: {
        key: 'strings:game.cards.progress.politics.back.body'
    },
    [CardEnum.ProgressCardPoliticsBishop]: {
        key: 'strings:game.cards.progress.politics.bishop.body'
    },
    [CardEnum.ProgressCardPoliticsConstitution]: {
        key: 'strings:game.cards.progress.politics.constitution.body'
    },
    [CardEnum.ProgressCardPoliticsDeserter]: {
        key: 'strings:game.cards.progress.politics.deserter.body'
    },
    [CardEnum.ProgressCardPoliticsDiplomat]: {
        key: 'strings:game.cards.progress.politics.diplomat.body'
    },
    [CardEnum.ProgressCardPoliticsIntrigue]: {
        key: 'strings:game.cards.progress.politics.intrigue.body'
    },
    [CardEnum.ProgressCardPoliticsSaboteur]: {
        key: 'strings:game.cards.progress.politics.saboteur.body'
    },
    [CardEnum.ProgressCardPoliticsSpy]: {
        key: 'strings:game.cards.progress.politics.spy.body'
    },
    [CardEnum.ProgressCardPoliticsWarlord]: {
        key: 'strings:game.cards.progress.politics.warlord.body'
    },
    [CardEnum.ProgressCardPoliticsWedding]: {
        key: 'strings:game.cards.progress.politics.wedding.body'
    },
    [CardEnum.ProgressCardScienceBack]: {
        key: 'strings:game.cards.progress.science.back.body'
    },
    [CardEnum.ProgressCardScienceAlchemist]: {
        key: 'strings:game.cards.progress.science.alchemist.body'
    },
    [CardEnum.ProgressCardScienceCrane]: {
        key: 'strings:game.cards.progress.science.crane.body'
    },
    [CardEnum.ProgressCardScienceEngineer]: {
        key: 'strings:game.cards.progress.science.engineer.body'
    },
    [CardEnum.ProgressCardScienceInventor]: {
        key: 'strings:game.cards.progress.science.inventor.body'
    },
    [CardEnum.ProgressCardScienceIrrigation]: {
        key: 'strings:game.cards.progress.science.irrigation.body'
    },
    [CardEnum.ProgressCardScienceMedicine]: {
        key: 'strings:game.cards.progress.science.medicine.body'
    },
    [CardEnum.ProgressCardScienceMining]: {
        key: 'strings:game.cards.progress.science.mining.body'
    },
    [CardEnum.ProgressCardSciencePrinter]: {
        key: 'strings:game.cards.progress.science.printer.body'
    },
    [CardEnum.ProgressCardScienceRoadBuilding]: {
        key: 'strings:game.cards.progress.science.roadBuilding.body'
    },
    [CardEnum.ProgressCardScienceSmith]: {
        key: 'strings:game.cards.progress.science.smith.body'
    },
    [CardEnum.ProgressCardBack]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.ResourceOverLimit]: {
        key: 'strings:game.playerInformation.resourceCard.body'
    }
};
export const CARD_POPUP_BODY = {
    [CardEnum.ResourceBack]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.Lumber]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.Brick]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.Wool]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.Grain]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.Ore]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.Cloth]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.Coin]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.Paper]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.AnyResource]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.DevelopmentBack]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.Knight]: {
        key: 'strings:game.cards.development.knight.popupBody'
    },
    [CardEnum.VictoryPoint]: {
        key: 'strings:game.cards.development.victoryPoint.popupBody'
    },
    [CardEnum.Monopoly]: {
        key: 'strings:game.cards.development.monopoly.popupBody'
    },
    [CardEnum.RoadBuilding]: {
        key: 'strings:game.cards.development.roadBuilding.popupBody'
    },
    [CardEnum.YearOfPlenty]: {
        key: 'strings:game.cards.development.yearOfPlenty.popupBody'
    },
    [CardEnum.CommodityBack]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.ProgressCardTradeBack]: {
        key: 'strings:game.cards.progress.trade.back.popupBody'
    },
    [CardEnum.ProgressCardTradeCommercialHarbor]: {
        key: 'strings:game.cards.progress.trade.commercialHarbor.popupBody'
    },
    [CardEnum.ProgressCardTradeMasterMerchant]: {
        key: 'strings:game.cards.progress.trade.masterMerchant.popupBody'
    },
    [CardEnum.ProgressCardTradeMerchant]: {
        key: 'strings:game.cards.progress.trade.merchant.popupBody'
    },
    [CardEnum.ProgressCardTradeMerchantFleet]: {
        key: 'strings:game.cards.progress.trade.merchantFleet.popupBody'
    },
    [CardEnum.ProgressCardTradeResourceMonopoly]: {
        key: 'strings:game.cards.progress.trade.resourceMonopoly.popupBody'
    },
    [CardEnum.ProgressCardTradeCommodityMonopoly]: {
        key: 'strings:game.cards.progress.trade.commodityMonopoly.popupBody'
    },
    [CardEnum.ProgressCardPoliticsBack]: {
        key: 'strings:game.cards.progress.politics.back.popupBody'
    },
    [CardEnum.ProgressCardPoliticsBishop]: {
        key: 'strings:game.cards.progress.politics.bishop.popupBody'
    },
    [CardEnum.ProgressCardPoliticsConstitution]: {
        key: 'strings:game.cards.progress.politics.constitution.popupBody'
    },
    [CardEnum.ProgressCardPoliticsDeserter]: {
        key: 'strings:game.cards.progress.politics.deserter.popupBody'
    },
    [CardEnum.ProgressCardPoliticsDiplomat]: {
        key: 'strings:game.cards.progress.politics.diplomat.popupBody'
    },
    [CardEnum.ProgressCardPoliticsIntrigue]: {
        key: 'strings:game.cards.progress.politics.intrigue.popupBody'
    },
    [CardEnum.ProgressCardPoliticsSaboteur]: {
        key: 'strings:game.cards.progress.politics.saboteur.popupBody'
    },
    [CardEnum.ProgressCardPoliticsSpy]: {
        key: 'strings:game.cards.progress.politics.spy.popupBody'
    },
    [CardEnum.ProgressCardPoliticsWarlord]: {
        key: 'strings:game.cards.progress.politics.warlord.popupBody'
    },
    [CardEnum.ProgressCardPoliticsWedding]: {
        key: 'strings:game.cards.progress.politics.wedding.popupBody'
    },
    [CardEnum.ProgressCardScienceBack]: {
        key: 'strings:game.cards.progress.science.back.popupBody'
    },
    [CardEnum.ProgressCardScienceAlchemist]: {
        key: 'strings:game.cards.progress.science.alchemist.popupBody'
    },
    [CardEnum.ProgressCardScienceCrane]: {
        key: 'strings:game.cards.progress.science.crane.popupBody'
    },
    [CardEnum.ProgressCardScienceEngineer]: {
        key: 'strings:game.cards.progress.science.engineer.popupBody'
    },
    [CardEnum.ProgressCardScienceInventor]: {
        key: 'strings:game.cards.progress.science.inventor.popupBody'
    },
    [CardEnum.ProgressCardScienceIrrigation]: {
        key: 'strings:game.cards.progress.science.irrigation.popupBody'
    },
    [CardEnum.ProgressCardScienceMedicine]: {
        key: 'strings:game.cards.progress.science.medicine.popupBody'
    },
    [CardEnum.ProgressCardScienceMining]: {
        key: 'strings:game.cards.progress.science.mining.popupBody'
    },
    [CardEnum.ProgressCardSciencePrinter]: {
        key: 'strings:game.cards.progress.science.printer.popupBody'
    },
    [CardEnum.ProgressCardScienceRoadBuilding]: {
        key: 'strings:game.cards.progress.science.roadBuilding.popupBody'
    },
    [CardEnum.ProgressCardScienceSmith]: {
        key: 'strings:game.cards.progress.science.smith.popupBody'
    },
    [CardEnum.ProgressCardBack]: {
        key: 'strings:colonistCommon.utils.emptyString'
    },
    [CardEnum.ResourceOverLimit]: {
        key: 'strings:colonistCommon.utils.emptyString'
    }
};
export const CARD_RATIO = 407 / 292 // Height / Width of cards
;
export const getIfCardHasBadgeFromType = (cardType, cardCount)=>{
    switch(cardType){
        case CardTypeEnum.Resource:
        case CardTypeEnum.Commodity:
            return true;
        case CardTypeEnum.ProgressTrade:
        case CardTypeEnum.ProgressPolitics:
        case CardTypeEnum.ProgressScience:
        case CardTypeEnum.Development:
            return cardCount > 1;
        case CardTypeEnum.AnyResource:
            return false;
        case CardTypeEnum.Miscellaneous:
            return false;
    }
};
export const cardEnumsToCardState = (cardEnums)=>{
    const cardState = {};
    for (const cardEnum of cardEnums){
        var _cardState_cardEnum;
        const currentCardCount = (_cardState_cardEnum = cardState[cardEnum]) !== null && _cardState_cardEnum !== void 0 ? _cardState_cardEnum : 0;
        cardState[cardEnum] = currentCardCount + 1;
    }
    return cardState;
};
